import { env } from 'next-runtime-env';

import { IPlaceFeature } from '../../models/search';
import resolveV2 from '../resolverV2';

export interface IPlacesResponse {
  attribution: string;
  features: IPlaceFeature[];
  query: string[];
  type: string;
}

interface IResponse {
  data: IPlacesResponse;
}

interface IResolvedPlaces {
  res: IResponse | null;
  err: Error | null;
}

export default async function getPlaces(
  txt: string,
  signal?: AbortSignal
): Promise<IResolvedPlaces> {
  const usa = '-125.332,23.079,-67.675,49.894';
  const token = env('NEXT_PUBLIC_MAPBOX_TOKEN');

  const encodedTxt = encodeURIComponent(txt);

  return resolveV2(
    {
      signal,
      url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodedTxt}.json?country=us&access_token=${token}&bbox=${usa}`,
    },
    {
      withCredentials: false,
    }
  );
}
